import { convertDatesToJsonUtc, ICrop, IFertiliserProduct, IFertiliserStock, IManureStock, IManureType, IOmniaSession, isArrayEmpty, ISeedStock, ITypedStock, IVariety, OmniaModuleId, OmniaService, SharedDataService, str } from "../omnia"
import { IAllStocks, IMmExport, IStocksService } from "../types"
import { StocksLoader } from "./loader"

export class StocksService extends OmniaService implements IStocksService {

    private loader = new StocksLoader(this.ohttp, this.sharedData)

    private _crops: ICrop[]
    private _stocks: ITypedStock[]

    static $inject = ["OmniaSession", "OmniaSharedData"]

    constructor(session: IOmniaSession, private sharedData: SharedDataService) {

        super(session, {
            name: str.Modules.Stocks,
            module: OmniaModuleId.Stocks,
            dependencies: [sharedData]
        })

    }

    getRefreshPromise(): ng.IPromise<any> {

        const { holdingId, yearId, holding: { Region: region } } = this

        return this.loader.load(holdingId, yearId, region).then(() => {

            this.setupCrops()
            this.setupStocks()

        })

    }

    shouldRefresh() {

        const changes = this.apiState.getChangesFromSource(
            this._changeNumber,
            s => (s == OmniaModuleId.Stocks)
                || (s == OmniaModuleId.Nutrition)
                || (s == OmniaModuleId.Seeds)
                || (s == OmniaModuleId.FieldDiary)
                || (s == OmniaModuleId.Manure)
                || (s == "refresh-all")
                || (!s)
        )

        return !isArrayEmpty(changes)

    }

    getCrops(): ICrop[] {
        return this._crops
    }

    getCropVarieties(crop: ICrop): IVariety[] {
        return crop.Varieties
    }

    getFertiliserProducts(): IFertiliserProduct[] {
        return this.sharedData.fertiliserProducts
    }

    getSeedStocks(): ISeedStock[] {
        return this.loader.getSeedStocks()
    }

    getFertiliserStocks(): IManureStock[] {
        return this.loader.getFertiliserStocks()
    }

    getManureTypes(): IManureType[] {
        return this.loader.getManureTypes()
    }

    getManureTypesForYear(year: number): ng.IPromise<IManureType[]> {
        return this.loader.getManureTypesForYear(year)
    }

    getStocks(): ITypedStock[] {
        return this._stocks
    }

    getManureStocks(): IManureStock[] {
        return this.loader.getManureStocks()
    }

    getManureExports(): IMmExport[] {
        return this.loader.getManureExports()
    }

    private setupStocks() {

        var seeds = this.loader.getSeedStocks()
        var fertilisers = this.loader.getFertiliserStocks()

        var manure = this.loader.getManureStocks()
        manure = manure.filter(s => !s.Hidden)

        this._stocks = Array.prototype.concat(seeds, fertilisers, manure)

    }


    private setupCrops() {

        this._crops = this.sharedData.crops
            .sort((c1, c2) => c1.Name.localeCompare(c2.Name))

    }

    getStocksForYear(yearId: number): ng.IPromise<IAllStocks> {

        return this.loader.getStocksForYear(yearId)

    }


    editSeedStock(stock: ISeedStock): ng.IPromise<ISeedStock> {

        const url = "/api/stocks/seed/edit"

        return this.post(url, getStockPostModel(stock))

    }

    editFertiliserStock(stock: IFertiliserStock): ng.IPromise<any> {

        const url = "/api/stocks/fertiliser/edit"

        return this.post(url, getStockPostModel(stock))

    }

    editManureStock(stock: IManureStock): ng.IPromise<any> {

        const url = "/api/stocks/manure/edit"

        const data = getStockPostModel(stock)

        convertDatesToJsonUtc(data)

        return this.post(url, data)

    }

    deleteStock(stock: ITypedStock): ng.IPromise<void> {

        const data = {
            holdingId: stock.HoldingId,
            year: stock.YearId,
            stockType: stock.StockType,
            stockId: stock.StockId
        }

        const url = "/api/stocks/v1/delete"

        return this.delete(url, data)

    }


}

function getStockPostModel(stock: any) {

    const { Holding, Year, Crop, Variety, ManureType, NvzManureType, StandardProduct, Plans, ...model } = stock

    return model

}
